module.exports = __webpack_public_path__ + "img/pharmaMarker.fe7e490f.png";